import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { Injectable, inject } from "@angular/core";
import { ClientConfigService } from "@app/core/config/client-config.service";

@Injectable()
export class TelemetryProviderService {
  private clientConfigService = inject(ClientConfigService);

  appInsights: ApplicationInsights;

  init(userId: string) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey:
          this.clientConfigService.config.applicationInsights
            .instrumentationKey,
        enableAutoRouteTracking: true, // option to log all route changes
        accountId: userId
      }
    });
    this.appInsights.loadAppInsights();
    this.appInsights.trackPageView(); // Tracks initial page view
  }

  logPageView(name?: string, url?: string) {
    // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  logMetric(
    name: string,
    average: number,
    properties?: { [key: string]: any }
  ) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({
      exception: exception,
      severityLevel: severityLevel
    });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message }, properties);
  }
}
